module.exports = __webpack_public_path__ + "assets/79df0a164a4c967d689b66489184f829.mp4";